/* global cco */
module.exports = function ccoConfigGet(key, defaultValue) {
  var config = cco.config || [],
    item = config.find(function (obj) {
      return obj.key === key;
    });
  return item ? item.value : defaultValue;
};